import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_FR.json';
import exercises from './YOGA_EXERCISES_FR.json';
import recipes from './YOGA_RECIPES_FR.json';

export const YOGA_DATA_FR: ServiceData = {
  articles,
  exercises,
  recipes,
};
